let initialized = false

export function initDocumentCard() {
  const elem = document.getElementsByClassName('tabs-container')[0]

  if (elem) {
    const observer = new ResizeObserver((entries) => {
      const height = Math.round(entries[0].borderBoxSize[0].blockSize) + 20

      document.dispatchEvent(new CustomEvent('document-card:size-changed', {
        detail: { height }
      }))
    })

    observer.observe(elem)
  }

  if (!initialized) {
    initialized = true

    document.addEventListener('click', (event) => {
      if (event.target.matches('.tol_link')) {
        const id = event.target.getAttribute('data-docid')
        document.dispatchEvent(new CustomEvent('document-card:document-link-clicked', {
          detail: { docid: id }
        }))
      }
    })
  }
}
